<template>
  <div class="hot-author">
    <div class="hot-author-title">本月最热作者</div>
    <div class="hot-author-item" v-for="(item, index) in hotUsers"  :key="index"  @click="goUserCenter(index)">
      <img class="hot-author-medals" :src="getImg(index)">
      <img class="hot-author-avatar" :src="item.avatar">
      <div class="hot-author-right">
        <div>{{item.nickname}}</div>
        <div>收获 {{item.pv.toString().length > 5 ? (item.pv/1000).toFixed(1) + 'k' : item.pv}} 个目光</div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapGetters, mapActions} from 'vuex'
import gold from '@/assets/img/hotauthor/gold.png';
import silver from '@/assets/img/hotauthor/silver.png';
import bronze from '@/assets/img/hotauthor/bronze.png';
export default {
  name: 'hot-author',
  data () {
    return {
      medals: [gold, silver, bronze], // 奖牌
    }
  },
  computed: {
    ...mapGetters('home', ['hotUsers'])
  },
  methods : {
    ...mapActions('home', ['getHotUsers']),
    getImg (val) {
      return this.medals[val]
    },
    goUserCenter(index){
      window.open('/usercenter/'+ this.hotUsers[index].uid)
    }
  },
  created () {
    this.getHotUsers()
  }
}
</script>
<style lang="scss" scoped>
.hot-author{
  height: 400px;
  >.hot-author-title {
    text-align: left;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    height: 60px;
    line-height: 60px;
    border-bottom :1px solid rgba(234,234,234,1);
  }
  .hot-author-item {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin: 20px 0;
    width: 200px;
    height: 48px;
    position: relative;
    &:hover {
      cursor: pointer;
    }
    >.hot-author-medals {
      width: 24px;
      position: absolute;
      left: 0;
    }
    >.hot-author-avatar {
      width: 48px;
      border-radius: 24px;
      margin-right: 70px;
    }
    >.hot-author-right {
      position: absolute;
      width: 100px;
      height: 100%;
      right: 0;
      top: 0;
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      >:first-child{
        font-size: 14px;
        color: #333333;
        margin-bottom: 6px;
        text-align: left;
      }
      >:nth-child(2) {
        font-size: 12px;
        color: #999999;
        text-align: left;
      }
    }
  }
}
</style>


